import { render, staticRenderFns } from "./OperatorsRegistryNewForm.vue?vue&type=template&id=52fbeb1a"
import script from "./OperatorsRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./OperatorsRegistryNewForm.vue?vue&type=script&lang=js"
import style0 from "./OperatorsRegistryNewForm.vue?vue&type=style&index=0&id=52fbeb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports